import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChefHat, CheckCircle2, Clock, Trash2 } from "lucide-react";

const PortalAccountsTab = ({ accounts, onVerify, onDelete }) => (
  <Card className="bg-card border-border">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <ChefHat className="w-5 h-5 text-primary" />
        Restaurant-Portal Registrierungen
      </CardTitle>
      <p className="text-sm text-muted-foreground">
        Neue Registrierungen müssen von dir freigeschaltet werden, bevor das Restaurant Gästedaten sehen kann.
      </p>
    </CardHeader>
    <CardContent>
      {accounts.length === 0 ? (
        <p className="text-muted-foreground text-center py-8">Keine Registrierungen vorhanden</p>
      ) : (
        <div className="space-y-3">
          {accounts.map((acc) => (
            <div
              key={acc.account_id}
              className={`flex flex-wrap items-center justify-between gap-3 p-4 rounded border ${acc.verified ? 'border-border bg-muted/10' : 'border-primary/40 bg-primary/5'}`}
              data-testid={`portal-account-${acc.account_id}`}
            >
              <div>
                <div className="flex items-center gap-2">
                  <p className="font-semibold">{acc.restaurant_name}</p>
                  {acc.verified ? (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-green-500/15 text-green-600 flex items-center gap-1">
                      <CheckCircle2 className="w-3 h-3" /> Freigeschaltet
                    </span>
                  ) : (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary/15 text-primary flex items-center gap-1">
                      <Clock className="w-3 h-3" /> Wartet auf Freischaltung
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground">
                  {acc.email}{acc.location ? ` • ${acc.location}` : ""}{acc.contact_person ? ` • ${acc.contact_person}` : ""}
                </p>
                <p className="text-xs text-muted-foreground">
                  Registriert: {acc.created_at ? new Date(acc.created_at).toLocaleDateString('de-DE') : "-"}
                </p>
              </div>
              <div className="flex gap-2">
                {acc.verified ? (
                  <Button
                    variant="outline" size="sm"
                    onClick={() => onVerify(acc.account_id, false)}
                    className="border-border text-muted-foreground"
                    data-testid={`portal-revoke-${acc.account_id}`}
                  >
                    Sperren
                  </Button>
                ) : (
                  <Button
                    size="sm"
                    onClick={() => onVerify(acc.account_id, true)}
                    className="bg-primary text-primary-foreground hover:bg-primary/90"
                    data-testid={`portal-verify-${acc.account_id}`}
                  >
                    <CheckCircle2 className="w-4 h-4 mr-1" /> Freischalten
                  </Button>
                )}
                <Button
                  variant="outline" size="sm"
                  onClick={() => onDelete(acc.account_id)}
                  className="border-destructive/40 text-destructive hover:bg-destructive/10"
                  data-testid={`portal-delete-${acc.account_id}`}
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default PortalAccountsTab;
